import React from 'react';
import { LayoutDashboard, FileText, ListChecks, Flag } from 'lucide-react';

interface AuditSidebarProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
    isOpen: boolean;
}

const AuditSidebar: React.FC<AuditSidebarProps> = ({ activeTab, onTabChange, isOpen }) => {
    const menuItems = [
        { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
        { id: 'procedures', label: 'Procedures', icon: <FileText size={20} /> },
        { id: 'my-procedures', label: 'My Procedures', icon: <ListChecks size={20} /> },
        { id: 'my-findings', label: 'My Findings', icon: <Flag size={20} /> },
    ];

    return (
        <div className={`audit-sidebar ${isOpen ? 'expanded' : 'collapsed'}`}>
            <nav className="audit-sidebar-nav">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        data-testid={`NAV_audit_sidebar_${item.id}`}
                        className={`audit-nav-item ${activeTab === item.id ? 'active' : ''}`}
                        onClick={() => onTabChange(item.id)}
                        title={!isOpen ? item.label : undefined}
                    >
                        <span className="audit-nav-icon">{item.icon}</span>
                        {isOpen && <span className="audit-nav-label">{item.label}</span>}
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default AuditSidebar;
